export default function(value) {
  return Math.round(value)
    .toString()
    .replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
}


// WEBPACK FOOTER //
// ./src/utils/indianize.js